// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"WhatInBox_thecomp__JPFyR"};